/*
 *
 *  remotes
 *
 */

import api from "../../helpers/Api"
//import constantName from './key'

/**
 *
 * @param {string} metaData
 * @returns
 */

export function loadRecordsMetaData(metaData, method) {
  if (method === "post") {
    return api
      .post(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return api
      .get(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}

export function loadLeadRecordsMetaDataDetails(metaData, method) {
  if (method === "post") {
    return api
      .post(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return api
      .get(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}

// permission details
export async function loadManageLeadDetails(searchvalue) {
  if (searchvalue) {
    return await api
      .post(`/get_all_manage_lead`, searchvalue)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return await api
      .post(`/get_all_manage_lead`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}
export async function loadCustomFieldsDetails(customFields) {
  
    return await api
      .post(`/get_all_custom_field`, customFields)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  
}

//add followup remote

export function addManageLeadDetails(leadDetails) {
  return api
    .post(`/add_lead`, leadDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export function updateManageLeadDetails(leadDetails) {
  return api
    .put(`/update_lead_by_id`, leadDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export function deleteManageLeadDetails(leadDetails) {
  return api
    .put(`/delete_lead_by_id`, leadDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}
export function leadStatusDetails(leadStatus) {
  return api
    .post(`/add_lead_assign`, leadStatus)
    .catch((error) => Promise.reject(error))
}

const remotes = {
  loadRecordsMetaData,
  loadLeadRecordsMetaDataDetails,
  loadManageLeadDetails,
  addManageLeadDetails,
  deleteManageLeadDetails,
  leadStatusDetails,
  loadCustomFieldsDetails
}

export default remotes
